import type { Target, Variants } from 'framer-motion'

export type Role = 'tertiaryLeft' | 'secondaryLeft' | 'main' | 'secondaryRight' | 'tertiaryRight'

export const STAGE_WIDTH = 1100
export const STAGE_HEIGHT = 340

export const ANIMATION = {
  DURATION: 1.2,
  EASING: [0.29, 0.43, 0.24, 0.98] as const,
}

export const SIZE: Record<Role, { width: number; height: number }> = {
  main: { width: 560, height: 320 },
  secondaryLeft: { width: 460, height: 260 },
  secondaryRight: { width: 460, height: 260 },
  tertiaryLeft: { width: 360, height: 200 },
  tertiaryRight: { width: 360, height: 200 },
}

export const OFFSET_X: Record<Role, number> = {
  main: 0,
  secondaryLeft: -132,
  secondaryRight: 132,
  tertiaryLeft: -265,
  tertiaryRight: 265,
}

export const OFFSET_Y: Record<Role, number> = {
  main: 0,
  secondaryLeft: 30,
  secondaryRight: 30,
  tertiaryLeft: 60,
  tertiaryRight: 60,
}

export const Z_INDEX: Record<Role, number> = {
  main: 50,
  secondaryLeft: 30,
  secondaryRight: 30,
  tertiaryLeft: 10,
  tertiaryRight: 10,
}

export function geometry(role: Role): Target {
  const { width, height } = SIZE[role]
  return {
    left: STAGE_WIDTH / 2 - width / 2 + OFFSET_X[role],
    top: OFFSET_Y[role],
    width,
    height,
    opacity: 1,
    zIndex: Z_INDEX[role],
  }
}

export function edgeGeometry(side: 'left' | 'right'): Target {
  const role: Role = side === 'left' ? 'tertiaryLeft' : 'tertiaryRight'
  const base = geometry(role)
  const push = side === 'left' ? -140 : 140
  return { ...base, left: (base.left as number) + push, opacity: 0 }
}

const POSITION_TRANSITION = {
  default: { duration: 0.8, ease: [0.65, 0, 0.35, 1] as const },
  opacity: { duration: 0.4, ease: 'easeInOut' as const },
} as const

export const cardVariants: Variants = {
  tertiaryLeft: { ...geometry('tertiaryLeft'), transition: POSITION_TRANSITION },
  secondaryLeft: { ...geometry('secondaryLeft'), transition: POSITION_TRANSITION },
  main: { ...geometry('main'), transition: POSITION_TRANSITION },
  secondaryRight: { ...geometry('secondaryRight'), transition: POSITION_TRANSITION },
  tertiaryRight: { ...geometry('tertiaryRight'), transition: POSITION_TRANSITION },
}

export const mainContentVariants: Variants = {
  hidden: { opacity: 0, transition: { duration: 0.2, ease: 'easeIn' } },
  visible: {
    opacity: 1,
    transition: { delay: 0.3, duration: 0.35, ease: 'easeOut' },
  },
}
